(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["misy-summer-light"] && !Shopify.designMode) return;
  try {
    
  const initialiseMisySummerLight = (root) => {
    if (!root || root.dataset.misyEnhanced === 'true') return;
    root.dataset.misyEnhanced = 'true';

    const scrollArea = root.querySelector('[data-misy-scroll]');
    const frames = [...root.querySelectorAll('[data-misy-frame]')];
    const progress = root.querySelector('[data-misy-progress]');
    const variantSelect = root.querySelector('[data-misy-variant]');
    const price = root.querySelector('[data-misy-price]');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const saveData = navigator.connection && navigator.connection.saveData;

    if (variantSelect && price) {
      variantSelect.addEventListener('change', () => {
        const option = variantSelect.selectedOptions[0];
        if (option && option.dataset.price) price.textContent = option.dataset.price;
      });
    }

    if (!scrollArea || frames.length < 2 || reducedMotion || saveData) {
      root.dataset.motion = 'static';
      return;
    }

    const controller = new AbortController();
    root.misySummerLightController = controller;
    let frameRequest = 0;
    let activeIndex = 0;

    const update = () => {
      frameRequest = 0;
      const rect = scrollArea.getBoundingClientRect();
      const distance = Math.max(scrollArea.offsetHeight - window.innerHeight, 1);
      const ratio = Math.min(1, Math.max(0, -rect.top / distance));
      const nextIndex = Math.round(ratio * (frames.length - 1));

      if (nextIndex !== activeIndex) {
        frames[activeIndex].classList.remove('is-active');
        frames[nextIndex].classList.add('is-active');
        activeIndex = nextIndex;
      }

      if (progress) progress.style.transform = `scaleX(${ratio})`;
    };

    const scheduleUpdate = () => {
      if (!frameRequest) frameRequest = window.requestAnimationFrame(update);
    };

    window.addEventListener('scroll', scheduleUpdate, { passive: true, signal: controller.signal });
    window.addEventListener('resize', scheduleUpdate, { passive: true, signal: controller.signal });
    update();
  };

  const initialiseAllMisySummerLight = (scope = document) => {
    scope.querySelectorAll('[data-misy-summer-light]').forEach(initialiseMisySummerLight);
  };

  initialiseAllMisySummerLight();

  document.addEventListener('shopify:section:load', (event) => {
    initialiseAllMisySummerLight(event.target);
  });

  document.addEventListener('shopify:section:unload', (event) => {
    const root = event.target.querySelector('[data-misy-summer-light]');
    if (root && root.misySummerLightController) root.misySummerLightController.abort();
  });

  } catch(e) { console.error(e); }
})();
})();
